import React from 'react';

interface InDrawerConfirmProps {
  isOpen: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmButtonText?: string;
}

const InDrawerConfirm: React.FC<InDrawerConfirmProps> = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmButtonText = 'Hapus',
}) => {
  if (!isOpen) return null;

  return (
    <div className='absolute inset-0 flex items-center justify-center z-[80]'>
      <div className='absolute inset-0 bg-[#1c243b] bg-opacity-80 backdrop-blur-sm' onClick={onCancel} />
      <div className='bg-[#212a40] p-6 rounded-lg shadow-xl z-[81] w-96 max-w-[90%] border border-[#2d3649]'>
        <h3 className='text-xl font-semibold text-white mb-2'>{title}</h3>
        <p className='text-gray-300 mb-6'>{message}</p>
        <div className='flex justify-end space-x-3'>
          <button
            className='px-4 py-2 bg-[#2a334a] text-gray-300 rounded-md hover:bg-[#344058] transition-colors'
            onClick={onCancel}
          >
            Batal
          </button>
          <button className='px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors' onClick={onConfirm}>
            {confirmButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InDrawerConfirm;
